<div class="modal inmodal fade in create-folder-modal" [ngClass]="{'show': ds.isCreateFolderModalShow}">
    <div class="modal-dialog">
        <div class="modal-content" [ngClass]="{'sk-loading': isPermissionsLoading || isShowPreloader}">
            <div class="modal-header">
                <button type="button" class="close" (click)="ds.hideCreateFolderModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">Create Folder</h4>
            </div>
            <div class="modal-body">
                <form #form="ngForm" (submit)="onSubmit(form, $event)" [ngClass]="{'ng-submitted': form.submitted}"
                      autocomplete="off">
                    <div class="row m-b-sm" *ngIf="corporationNumbers && 
                                            !(corporationNumbers.length == 1 &&
                                            data.corporationNumbers.length == 1)">
                        <div class="col-md-4">
                            <label>Corporations</label>
                        </div>
                        <div class="col-md-8">
                            <angular2-multiselect name="corporationNumbers"
                                                  required
                                                  [data]="corporationNumbers"
                                                  [(ngModel)]="data.corporationNumbers"
                                                  (onSelect)="getBuildingsForSelectedCorporations()"
                                                  (onDeSelect)="getBuildingsForSelectedCorporations($event, 'deselect')"
                                                  (onSelectAll)="getBuildingsForSelectedCorporations()"
                                                  (onDeSelectAll)="getBuildingsForSelectedCorporations($event, 'deselectAll')"
                                                  [settings]="{
                                                      singleSelection: false,
                                                      text: 'Select Corporations',
                                                      selectAllText: 'Select All',
                                                      unSelectAllText: 'Deselect All',
                                                      enableSearchFilter: true,
                                                      scrollable: true,
                                                      classes: 'with-filter'
                                                  }">
                            </angular2-multiselect>
                        </div>
                    </div>

                    <div class="row m-b-sm" *ngIf="buildings && buildings.length &&
                                                !(buildings.length == 1 &&
                                                data.buildings.length == 1)">
                        <div class="col-md-4">
                            <label>Buildings</label>
                        </div>
                        <div class="col-md-8">
                            <angular2-multiselect name="buildings"
                                                  required
                                                  [data]="buildings"
                                                  [(ngModel)]="data.buildings"
                                                  [settings]="{
                                                      singleSelection: false,
                                                      text: 'Select Buildings',
                                                      selectAllText: 'Select All',
                                                      unSelectAllText: 'Deselect All',
                                                      enableSearchFilter: true,
                                                      scrollable: true,
                                                      classes: 'with-filter'
                                                  }">
                            </angular2-multiselect>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Folder Name</label>
                        </div>
                        <div class="col-md-8">
                            <input [ngModel]="data.name"
                                   (input)="onNameChange($event.target.value)"
                                   name="name"
                                   type="text"
                                   class="form-control"
                                   #folderNameInput
                                   required/>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Sharing</label>
                        </div>
                        <div class="col-md-8">
                            <select class="form-control" name="isPublic" [(ngModel)]="shareType"
                                    (ngModelChange)="shareTypeChange($event)">
                                <option [ngValue]="null">Staff only</option>
                                <option *ngFor="let option of currentShareTypeOptions"
                                        [ngValue]="option.value">{{option.name}}</option>
                            </select>
                        </div>
                    </div>

                    <ng-container *ngIf="hasAcceptableDates">
                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Visible from</label>
                            </div>
                            <div class="col-md-8">
                                <date-select-field name="acceptableFrom" [(ngModel)]="visibleFrom"></date-select-field>
                            </div>
                        </div>

                        <div class="row m-b-sm">
                            <div class="col-md-4">
                                <label>Visible to</label>
                            </div>
                            <div class="col-md-8">
                                <date-select-field name="acceptableTo"
                                                   [minDate]="visibleFrom"
                                                   [(ngModel)]="visibleTo"></date-select-field>
                            </div>
                        </div>
                    </ng-container>

                    <div *ngIf="shareType === shareTypes.Residents && permissionsList.length" class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Occupancy Types</label>
                        </div>
                        <div class="col-md-8">
                            <permissions-select [permissionsList]="permissionsList"
                                                [permissions]="data.permissions"
                                                (onChange)="onPermissionsChange($event)">
                            </permissions-select>
                        </div>
                    </div>

                    <div *ngIf="shareType === shareTypes.Groups" class="row m-b-sm">
                        <div class="col-md-4">
                            <label>User Groups</label>
                        </div>
                        <div class="col-md-8">
                            <angular2-multiselect name="userGroups"

                                                  [data]="userGroups"
                                                  [(ngModel)]="data.userGroups"
                                                  [settings]="{
                                                      singleSelection: false,
                                                      text: 'Select User Groups',
                                                      selectAllText: 'Select All',
                                                      unSelectAllText: 'Deselect All',
                                                      enableSearchFilter: true,
                                                      classes: 'with-filter'
                                                  }">
                            </angular2-multiselect>
                        </div>
                    </div>

                    <div class="btns-box m-t-md">
                        <button type="submit" [disabled]="isShowPreloader"
                                class="btn btn-primary save-folder-btn m-t-md">Save
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <spinner [spinnerShow]="isPermissionsLoading || isShowPreloader || isCorporationLoading"></spinner>
    </div>
    <div class="modal-backdrop fade in" (click)="!isShowPreloader && ds.hideCreateFolderModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/documents/create-folder-modal/create-folder-modal.component.html